import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qr-download-container p-3 d-flex flex-column align-items-stretch mt-3 rounded-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "qrcode qr-via-image mx-4 align-self-center bg-white p-2 rounded-3",
  id: "qrcode"
}, null, -1)
const _hoisted_3 = { class: "m-0 text-center text-black fw-semibold text-qr" }
const _hoisted_4 = { class: "my-3 text-p-via-img text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString($setup.local.share_image_part_1), 1)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString($setup.local.share_image_part_2), 1)
  ], 64))
}